module.exports = __webpack_public_path__ + "static/media/Golett_gaussian2.55ded313.png";